export default "__VITE_ASSET__BQIeau0i__"